/**
 * UI компоненты: аккордеон, модалки, toggle
 */

// Константы для настройки UI
var SCROLL_OFFSET_EXTRA = 0; // Дополнительный отступ сверху при скролле к термину (в пикселях)
var SCROLL_VISIBLE_BUFFER = 70; // Зазор для проверки видимости термина (скроллим только если вне этого диапазона)

/**
 * Суммирует высоты всех sticky/fixed-закреплённых элементов сверху страницы,
 * которые перекрывают область у верхнего края viewport. Учитывает только
 * элементы с `position: sticky|fixed` и видимые (не hidden, не display:none).
 * Нужен, чтобы скролл к `.zaglavie` оставлял его НИЖЕ всех пинов — а не под
 * одной из двух панелей (форма + breadcrumb).
 */
function _getStickyOffsetSum() {
  var total = 0;
  var candidates = [
    document.querySelector('.search-form-container'),
    document.getElementById('chain-breadcrumb')
  ];
  for (var i = 0; i < candidates.length; i++) {
    var el = candidates[i];
    if (!el) continue;
    if (el.hidden || el.offsetParent === null) continue;
    var pos = getComputedStyle(el).position;
    if (pos !== 'sticky' && pos !== '-webkit-sticky' && pos !== 'fixed') continue;
    total += el.offsetHeight;
  }
  return total || 70; // fallback как раньше — если ничего не нашлось
}

// Фикс для iOS: если сворачиваемое определение полностью выше viewport,
// скрываем его мгновенно (без slideUp) — браузерное scroll-anchoring удержит
// визуальную позицию цели. Избавляет от iOS-бага «маленькое уходит за верхний
// край экрана» при раскрытии после большого. На других платформах оставляем
// старое поведение (slideUp 300ms). Флаг для быстрого отката.
var IOS_FAST_COLLAPSE = true;
function _isIOSLike() {
  var ua = navigator.userAgent || '';
  // iPad на iOS 13+ маскируется под Mac, но имеет тач — ловим через maxTouchPoints.
  var isIPad = /Macintosh/.test(ua) && navigator.maxTouchPoints > 1;
  return /iPhone|iPod|iPad/.test(ua) || isIPad;
}

// Инициализация аккордеона
function initAccordion() {
  $('.descr').hide();
  $('.zaglavie').off('click').on('click', function(e){
    // Игнорируем клики по кнопкам действий статьи (редактирование, отправка
    // в TG, кебаб-меню и его панель) — обрабатываются отдельными обработчиками
    if ($(e.target).closest('.edit-entry-btn, .tg-send-btn, .zaglavie-more-btn, .zaglavie-more-menu').length > 0) {
      return;
    }
    
    e.preventDefault();
    e.stopPropagation();

    var $zaglavie = $(this);
    var index = $('.zaglavie').index($zaglavie);
    
    expandTermByIndex(index, false);
  }).on('blur', function() {
    $(this).removeClass('kbd-focus');
  });
  
  autoExpandSingleResult();
  // Пропускаем expandTermFromHash если морфинг-поток планирует свой отложенный
  // scroll через tryScrollFromHistory (morphing.js). Иначе получается 2 скролла:
  // первый — до того как sticky-панели (форма + breadcrumb) уложены в layout,
  // второй — корректирующий. Единственный отложенный вызов даёт правильный
  // offset с первого раза (учтёт обе sticky-панели).
  if (!window.PENDING_TERM_GUID && !window.PENDING_TERM_INDEX) {
    expandTermFromHash();
  }
  initKeyboardNavigation();
}

/**
 * Основная функция для управления состоянием термина (раскрытие, фокус, скролл)
 * @param {number} index - индекс термина (0-based)
 * @param {boolean} forceScroll - принудительный скролл даже если элемент виден
 */
function expandTermByIndex(index, forceScroll, isKbd) {
  var results = document.querySelectorAll('.opredelenie');
  if (index < 0 || index >= results.length) return;

  // Раскрытие/сворачивание термина (в т.ч. клавиатурная навигация) закрывает
  // открытое кебаб-меню действий — иначе панель может остаться висеть над
  // свернувшимся/уехавшим заголовком (term-menu.js).
  if (window.SEARCH_TERM_MENU && window.SEARCH_TERM_MENU.closeAll) {
    window.SEARCH_TERM_MENU.closeAll();
  }

  var target = results[index];
  var zaglavie = target.querySelector('.zaglavie');
  var $zaglavie = $(zaglavie);
  var $descr = $zaglavie.next('.descr');
  
  // Определяем, нужно ли разворачивать термин
  var isCurrentlyVisible = $descr.is(':visible');
  var shouldExpand = forceScroll || !isKbd;
  
  // Если навигация с клавиатуры (стрелки), разворачиваем только если 
  // ПРЕДЫДУЩИЙ активный термин был развернут (режим последовательного чтения)
  if (isKbd && !forceScroll) {
    var $prevActiveDescr = $('.zaglavie.active').next('.descr');
    if ($prevActiveDescr.length > 0 && $prevActiveDescr.is(':visible')) {
      shouldExpand = true;
    }
  }

  // Убираем active и kbd-focus у других
  $('.zaglavie').not($zaglavie).removeClass('active kbd-focus');
  $zaglavie.addClass('active kbd-focus'); // Всегда добавляем kbd-focus при активации термина

  // Read stable GUID from the element for URL anchor
  var termGuid = target.getAttribute('data-guid') || '';

  if (isCurrentlyVisible && !forceScroll && !isKbd) {
    // Если уже виден и мы просто кликнули - сворачиваем
    $descr.slideUp(300);
    $zaglavie.removeClass('expanded');

    // Clear hash (works for both old #term-N and new #guid format)
    if (window.location.hash) {
      history.replaceState(null, null, window.location.pathname + window.location.search);
    }
  } else if (shouldExpand) {
    // Раскрываем
    if (!isCurrentlyVisible) {
      // Сворачиваем остальные видимые. Спецкейс iOS: если схлопывающийся .descr
      // ПОЛНОСТЬЮ выше viewport — убираем без slideUp, чтобы scroll-anchoring
      // мгновенно подтянул scrollTop и цель визуально осталась на месте.
      // Включается флагом IOS_FAST_COLLAPSE; откат — `IOS_FAST_COLLAPSE = false;`.
      var useFastCollapse = IOS_FAST_COLLAPSE && _isIOSLike();
      $('.descr').filter(':visible').not($descr).each(function() {
        var $d = $(this);
        if (useFastCollapse && this.getBoundingClientRect().bottom <= 0) {
          $d.hide();
          $d.prev('.zaglavie').removeClass('expanded');
        } else {
          $d.slideUp(300).prev('.zaglavie').removeClass('expanded');
        }
      });

      $zaglavie.addClass('expanded');
      $descr.slideDown(300);
    }

    // Обновляем хэш: используем стабильный GUID (source_table:source_rowid),
    // fallback на позиционный #term-N если GUID отсутствует
    if (termGuid) {
      history.replaceState(null, null, '#' + termGuid);
    } else {
      history.replaceState(null, null, '#term-' + (index + 1));
    }

    // Обновляем активную запись истории: displayTerm = заголовок раскрытой статьи,
    // termGuid = стабильный идентификатор, termIndex = позиция (legacy fallback).
    // Мутация работает только если запись !locked.
    // # ⛓️ CURSOR_ANCHOR:search:history-hierarchy
    // Извлекаем только текст термина из .terms (без .dictname и кнопки Edit).
    var displayTerm = '';
    try {
      var termsEl = zaglavie.querySelector('.terms');
      displayTerm = termsEl ? (termsEl.textContent || '').trim() : (zaglavie.textContent || '').trim();
    } catch (e) {}
    if (window.updateActiveHistoryDisplay) {
      window.updateActiveHistoryDisplay(index + 1, displayTerm, termGuid);
    } else if (window.updateLastHistoryItem) {
      // Fallback на legacy API
      window.updateLastHistoryItem(index + 1);
    }
  }

  // Устанавливаем фокус
  zaglavie.focus({preventScroll: true});

  // Отложенный запуск скролла: 2 rAF, чтобы успели примениться:
  // — morphing fade-in (container classes),
  // — initAccordion slideDown/slideUp,
  // — sticky-слои (форма + breadcrumb) подхватили финальные размеры.
  // Без этой задержки в сетевом (не-кешовом) пути _getStickyOffsetSum
  // иногда возвращал неполную сумму, и статья уезжала под панель.
  requestAnimationFrame(function() {
    requestAnimationFrame(function() {
      performScrollToElement(zaglavie, target, forceScroll);
    });
  });
}

/**
 * Внутренняя функция скролла
 */
function performScrollToElement(zaglavie, opredelenie, forceScroll) {
  var $zaglavie = $(zaglavie);
  var $opredelenie = $(opredelenie);

  // Суммарная высота всех активно sticky/fixed элементов сверху viewport.
  // Когда breadcrumb забирает sticky у формы (наш CSS-override ставит форму в
  // position:relative) — в сумму попадёт только breadcrumb. Когда breadcrumb
  // скрыт — только форма. Если по какой-то причине обе закреплены сверху —
  // суммируются, и заголовок не уходит «под» ни одну из панелей.
  var stickyHeight = _getStickyOffsetSum();

  var offset = (stickyHeight || 70) + SCROLL_OFFSET_EXTRA;
  
  // Получаем абсолютное положение элемента в документе
  var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  var rect = zaglavie.getBoundingClientRect();
  var absoluteY = rect.top + scrollTop;
  
  // КРИТИЧНО: Если выше нашего целевого элемента есть другой развернутый элемент,
  // который сейчас в процессе сворачивания (slideUp), его высота еще занимает место.
  // Нам нужно вычесть высоту его .descr, так как он схлопнется и наш элемент "уедет" вверх.
  var $collapsingDescr = $('.descr:visible').not($opredelenie.find('.descr'));
  if ($collapsingDescr.length > 0) {
    var collapsingRect = $collapsingDescr[0].getBoundingClientRect();
    var collapsingTop = collapsingRect.top + scrollTop;
    
    // Если схлопывающийся элемент выше целевого
    if (collapsingTop < absoluteY) {
      absoluteY -= collapsingRect.height;
    }
  }

  // Целевая позиция - заголовок вверху под шапкой (с учетом корректировки)
  var targetY = Math.floor(absoluteY - offset);

  // УМНЫЙ СКРОЛЛ: Анализируем размер определения для выбора режима прокрутки
  var containerRect = opredelenie.getBoundingClientRect();
  var viewportHeight = window.innerHeight;
  var viewportAvailableHeight = viewportHeight - offset - SCROLL_VISIBLE_BUFFER;
  
  // Если определение занимает более 75% экрана, считаем его большим
  var isLargeEntry = containerRect.height > viewportAvailableHeight * 0.75;
  
  if (!isLargeEntry) {
    // ДЛЯ МАЛЕНЬКИХ: Пытаемся показать 2 предыдущих заголовка для контекста
    var $prevHeaders = $opredelenie.prevAll('.opredelenie').slice(0, 2).find('.zaglavie');
    var contextHeight = 0;
    $prevHeaders.each(function() {
      contextHeight += $(this).outerHeight();
    });
    
    // Ограничиваем "воздух", чтобы низ текущего определения гарантированно остался в экране
    var availableSpace = viewportAvailableHeight - containerRect.height;
    var contextAir = Math.min(contextHeight, Math.max(0, availableSpace - 10), 160); 
    
    if (contextAir > 0) {
      targetY -= Math.floor(contextAir);
      console.log('[SCROLL] Context air target calculated:', contextAir);
    }
  }

  if (targetY < 0) targetY = 0;

  // Проверяем, нужно ли скроллить.
  // Мы скроллим если:
  // 1. Принудительный скролл (forceScroll)
  // 2. Верх заголовка скрыт под шапкой (rect.top < offset)
  // 3. Низ определения ушел за экран (containerRect.bottom > viewportHeight - SCROLL_VISIBLE_BUFFER)
  // 4. ДЛЯ МАЛЕНЬКИХ: Если над заголовком меньше "воздуха", чем мы рассчитали (контекст не виден)
  
  var currentScroll = window.pageYOffset || document.documentElement.scrollTop;

  // Предиктивные координаты цели ПОСЛЕ завершения slideUp схлопывающегося выше
  // определения. Без этой коррекции early-return «цель в хорошей позиции» может
  // сработать, пока схлопывание ещё идёт, — и после завершения анимации цель
  // уедет выше viewport (баг «уходит за верхнюю границу экрана» на iOS).
  var effectiveRectTop = rect.top;
  var effectiveBottom = containerRect.bottom;
  if ($collapsingDescr.length > 0) {
    var shiftTop = $collapsingDescr[0].getBoundingClientRect().top + scrollTop;
    if (shiftTop < absoluteY) {
      var shiftH = $collapsingDescr[0].getBoundingClientRect().height;
      effectiveRectTop = rect.top - shiftH;
      effectiveBottom = containerRect.bottom - shiftH;
    }
  }

  var isTopHidden = effectiveRectTop < offset - 5;
  var isBottomHidden = effectiveBottom + SCROLL_VISIBLE_BUFFER > viewportHeight;

  // Проверка: виден ли желаемый контекст?
  // (только если мы не на самом верху списка, где контекста физически нет)
  var isContextMissing = !isLargeEntry && (effectiveRectTop < offset + (Math.min(targetY - (absoluteY - offset), 0) * -1) - 10);

  if (!forceScroll && !isTopHidden && !isBottomHidden && !isContextMissing) {
    console.log('[SCROLL] Already in good position, skipping');
    return;
  }

  console.log('[SCROLL] Scrolling to', targetY, {
    force: forceScroll,
    topHidden: isTopHidden,
    bottomHidden: isBottomHidden,
    contextMissing: isContextMissing
  });

  var $jq = window.jQuery || window.$;
  var scrollSuccess = false;
  if ($jq && typeof $jq.fn.animate === 'function') {
    try {
      $jq('html, body').stop(true, false).animate({
        scrollTop: targetY
      }, 300, 'swing', function() {
        scrollSuccess = true;
      });
    } catch (e) {}
  }

  if (!scrollSuccess) {
    window.scrollTo({
      top: targetY,
      behavior: 'smooth'
    });
  }
}

/**
 * Ищет индекс .opredelenie по GUID (data-guid="source_table:source_rowid").
 * Возвращает 0-based индекс или -1 если не найден.
 */
function findTermIndexByGuid(guid) {
  if (!guid) return -1;
  var el = document.querySelector('.opredelenie[data-guid="' + CSS.escape(guid) + '"]');
  if (!el) return -1;
  var all = document.querySelectorAll('.opredelenie');
  for (var i = 0; i < all.length; i++) {
    if (all[i] === el) return i;
  }
  return -1;
}

/**
 * Функция для развертывания по хэшу.
 * Поддерживает два формата:
 *   - Новый: #ScnTech_RU:4523 (стабильный GUID)
 *   - Legacy: #term-N (позиционный индекс, fallback)
 */
function expandTermFromHash() {
  var hash = window.location.hash;
  if (!hash || hash.length < 2) return;

  var raw = hash.substring(1); // убираем #
  var index = -1;

  if (raw.indexOf('term-') === 0) {
    // Legacy format: #term-N
    index = parseInt(raw.substring(5)) - 1;
    if (isNaN(index)) return;
  } else if (raw.indexOf(':') > 0) {
    // New format: #source_table:source_rowid (GUID)
    index = findTermIndexByGuid(raw);
    // If GUID not found yet, will retry below
  } else {
    return; // Unknown format
  }

  var attempts = 0;
  var maxAttempts = 20;
  var guid = (raw.indexOf(':') > 0) ? raw : null;

  var tryExpand = function() {
    var results = document.querySelectorAll('.opredelenie');

    // For GUID-based hash, re-lookup each attempt (results may still be loading)
    if (guid && index < 0) {
      index = findTermIndexByGuid(guid);
    }

    if (index >= 0 && index < results.length) {
      expandTermByIndex(index, true); // Принудительный скролл при переходе по ссылке
      // Анимация подсветки при открытии из истории / URL
      var target = results[index];
      var zag = target && target.querySelector('.zaglavie');
      if (zag) {
        zag.classList.add('history-highlight');
        setTimeout(function() { zag.classList.remove('history-highlight'); }, 1500);
      }
    } else if (attempts < maxAttempts) {
      attempts++;
      setTimeout(tryExpand, 200);
    }
  };

  tryExpand();
}

function autoExpandSingleResult() {
  var container = document.getElementById('results-container');
  if (!container) return;
  
  var $results = $(container).find('.opredelenie');
  if ($results.length === 1) {
    // Используем нашу новую функцию
    setTimeout(function() {
      // expandTermByIndex работает как TOGGLE (клик по раскрытому — сворачивает).
      // Единственный результат мог быть уже раскрыт восстановлением из хэша
      // (expandTermFromHash в initAccordion вызывается синхронно ДО этого
      // таймаута) — тогда повторный вызов СВЕРНУЛ бы его. Авто-раскрытие по
      // смыслу только раскрывает, никогда не сворачивает: пропускаем, если
      // descr уже виден (тот же критерий, что и ветка сворачивания в
      // expandTermByIndex).
      var $descr = $results.eq(0).find('.zaglavie').next('.descr');
      if ($descr.is(':visible')) return;
      expandTermByIndex(0, false);
    }, 100);
  }
}

function initDictNameHandlers() {
  // Зарезервировано
}

function updateTogglePosition() {
  var searchTypeGroup = document.querySelector('.search-type-group');
  if (!searchTypeGroup) return;
  
  var radios = searchTypeGroup.querySelectorAll('input[type="radio"]');
  var checkedIndex = -1;
  radios.forEach(function(radio, index) {
    if (radio.checked) checkedIndex = index;
  });
  
  if (checkedIndex >= 0) {
    searchTypeGroup.setAttribute('data-position', checkedIndex.toString());
  }
}

/**
 * Инициализация навигации клавишами вверх-вниз по результатам
 */
function initKeyboardNavigation() {
  if (window._resultsKeyHandler) {
    document.removeEventListener('keydown', window._resultsKeyHandler);
  }

  window._resultsKeyHandler = function(e) {
    // Если открыт дропдаун истории, не перехватываем
    var historyDropdown = document.getElementById('search-history-dropdown');
    if (historyDropdown && historyDropdown.classList.contains('active')) return;

    // Навигация если фокус в инпуте, на заголовках или на body (после загрузки)
    var isInputFocus = e.target.id === 'search';
    var isZaglavieFocus = e.target.classList.contains('zaglavie');
    var isBodyFocus = e.target === document.body || e.target === document.documentElement;

    if (isInputFocus || isZaglavieFocus || isBodyFocus) {
      // TAB / Shift-Tab всегда переключают фокус между строкой поиска и результатами
      if (e.key === 'Tab') {
        var $results = $('.zaglavie');
        if ($results.length > 0) {
          if (isInputFocus) {
            e.preventDefault();
            var $active = $results.filter('.active');
            if ($active.length > 0) {
              $active[0].focus();
              $active.addClass('kbd-focus');
            } else {
              expandTermByIndex(0, false, true);
            }
          } else if (isZaglavieFocus) {
            e.preventDefault();
            document.getElementById('search').focus();
          }
        }
      }

      // Стрелки Вправо/Влево для развертывания/свертывания
      if (isZaglavieFocus) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          var $zaglavie = $(e.target);
          var $descr = $zaglavie.next('.descr');
          var isExpanded = $descr.is(':visible');

          if (e.key === 'ArrowRight' && !isExpanded) {
            e.preventDefault();
            var index = $('.zaglavie').index($zaglavie);
            expandTermByIndex(index, true, true); // forceScroll=true здесь заставит развернуться
          } else if (e.key === 'ArrowLeft' && isExpanded) {
            e.preventDefault();
            var index = $('.zaglavie').index($zaglavie);
            // Для сворачивания вручную
            $descr.slideUp(300);
            $zaglavie.removeClass('expanded');
          }
        }
      }

      if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'PageDown' || e.key === 'PageUp') {
        var $results = $('.zaglavie');
        if ($results.length === 0) return;

        // Если фокус в инпуте и нажата стрелка Вверх - не перехватываем (может быть для истории)
        if (isInputFocus && (e.key === 'ArrowUp' || e.key === 'PageUp')) return;

        e.preventDefault();
        
        var $active = $results.filter('.active');
        var currentIndex = $results.index($active);
        var nextIndex = currentIndex;

        if (e.key === 'ArrowDown') {
          nextIndex = (currentIndex === -1) ? 0 : Math.min(currentIndex + 1, $results.length - 1);
        } else if (e.key === 'ArrowUp') {
          nextIndex = (currentIndex === -1) ? 0 : Math.max(currentIndex - 1, 0);
        } else if (e.key === 'PageDown') {
          // Прыгаем на 10 элементов вниз
          nextIndex = (currentIndex === -1) ? 9 : Math.min(currentIndex + 10, $results.length - 1);
        } else if (e.key === 'PageUp') {
          // Прыгаем на 10 элементов вверх
          nextIndex = (currentIndex === -1) ? 0 : Math.max(currentIndex - 10, 0);
        }

        if (nextIndex !== currentIndex || currentIndex === -1) {
          expandTermByIndex(nextIndex, false, true);
        }
      }
    }
  };

  document.addEventListener('keydown', window._resultsKeyHandler);
}

// Экспортируем API модуля
window.SEARCH_UI = {
  initAccordion: initAccordion,
  initDictNameHandlers: initDictNameHandlers,
  updateTogglePosition: updateTogglePosition,
  autoExpandSingleResult: autoExpandSingleResult,
  expandTermFromHash: expandTermFromHash,
  expandTermByIndex: expandTermByIndex
};

// Слушаем изменение хэша (для переходов назад-вперед в браузере)
window.addEventListener('hashchange', expandTermFromHash);
